import styled from "styled-components";

export const NavSlidingPlaceholder = styled.div``;

// @media (min-width: 768px) {
//   font-size: 2rem;
//   margin: 0;
// }
